import { B5, Pressable, SH3, XStack } from '@zet/design-system'

import { LeadHeaderCardProps } from '../api/leads/types'

const LeadHeaderCard = ({
  icon,
  leadCount,
  leadTitle,
  onPress,
}: LeadHeaderCardProps) => {
  return (
    <Pressable
      className="border-tertiary-20 grow border-r px-3 py-1"
      onPress={onPress}
    >
      <XStack className="items-center space-x-2">
        {icon}
        <SH3 className="text-white">{leadCount}</SH3>
      </XStack>
      <B5 className="text-grays-50 pt-1 leading-5">{leadTitle}</B5>
    </Pressable>
  )
}

export default LeadHeaderCard
